/**
 * APP配置
 */

// 环境配置
// 开发
export const isDev = process.env.NODE_ENV === 'development';

// 生产
export const isProd = process.env.NODE_ENV === 'production';

// 系统配置
export const appSystemInfo = {
	name: 'Shopee',
	// #ifdef MP-WEIXIN
	platform: 'wx',
	channelType: 2,
	channel: 'MIN',
	// #endif
	// #ifdef APP-PLUS
	platform: 'app',
	channelType: 1,
	channel: plus.os.name,
	// #endif
	// #ifdef H5
	platform: 'h5',
	channelType: 3,
	channel: 'wx',
	// #endif
	clientId: 'mall_apis',
	// clientSecret: 'APHGN0VXP4vynmCXfWqjDrCiLFP1EJez',
	clientSecret: 'e7cmucrchfvkp81g5qj35l3xtbr4srbm',
	areaCode:'+1',
	lang :'en',
	version: '1.0.0'
}

// 域名
export const baseUrl = (() => {
	if(isDev){
		return '/ai';
	}else{
		return '/api';
	}
})();

// 站内信实时通知 WebSocket 网关基址（仅 H5）
// dev：与 /ai 代理同一网关；prod：业务接口走同源 /api，WS 同域取当前页面 host
export const letterSocketBase = (() => {
	if(isDev){
		return 'wss://gateway.jygtest.top';
	}
	// #ifdef H5
	return `${location.protocol === 'https:' ? 'wss:' : 'ws:'}//${location.host}`;
	// #endif
	// #ifndef H5
	return '';
	// #endif
})();